<script lang="ts">
  import {onMount} from 'svelte';

  import {writable} from 'svelte/store';

  export let value: string;
  export let items: Array<any> = [];
  export let placeholder: string;
  export let deriveValue: (str: any) => any = input => input;
  export let deriveLabel: (str: any) => any = input => input;
  export let isFont = false;
  export let isClearable: boolean;
  let show = writable(false);
  let triggered = false;
  const onClick = item => {
    value = item ? deriveValue(item) : null;
  };
  const getLabel = item => {
    return item ? deriveLabel(item) : '';
  };
  const onDocumentClick = () => {
    if (triggered === true) {
      triggered = false;
      return;
    }
    show.update(() => false);
    triggered = false;
  };
  const toggleShow = () => {
    triggered = true;
    show.update(s => {
      return !s;
    });
  };

  const onDocumentKeydown = e => {
    if (e.keyCode == 27 && $show) {
      show.update(() => false);
    }
  };

  const getLabelStyle = item => {
    if (isFont) {
      return 'font-family: ' + item.label;
    }

    return '';
  };

  const clearSelection = () => {
    value = '';
  };

  $: displayClass = $show ? 'flex flex-col absolute top-0 left-0 p-4 bg-white main z-10' : 'hidden';
</script>

<svelte:window on:click={onDocumentClick} on:keydown={onDocumentKeydown} />
<div class="w-full">
  <span
    on:click={toggleShow}
    on:keydown={toggleShow}
    class="block w-full cursor-pointer overflow-visible rounded-md border-2 border-gray-200 bg-white p-2 text-sm text-zinc-700"
  >
    {value == 'default' || value == '' || !value ? placeholder : getLabel(value)}
    <i class="fa-solid fa-angle-down float-right py-1"> </i>
  </span>
  {#if isClearable && value}
    <button
      type="button"
      class="absolute right-0 top-0 rounded-r-lg bg-gray-200 p-2 text-sm font-bold text-gray-700 hover:bg-red-300 focus:outline-none focus:ring-4"
      on:click={clearSelection}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="h-6 w-6"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </button>
  {/if}
  <div class={displayClass}>
    {#each items as item}
      {#if item.isHeader}
        <div class="mb-3 block p-2 text-base font-bold">{item.placeholder}</div>
      {:else}
        <div
          class="block cursor-pointer p-2 hover:bg-gray-100"
          on:click={() => onClick(item)}
          on:keydown={() => onClick(item)}
        >
          <span style={getLabelStyle(item)}>{item.label}</span>
        </div>
      {/if}
    {/each}
  </div>
</div>

<style>
  div.main {
    width: 100%;
    max-height: 300px;
    overflow-y: scroll;
  }
</style>
